import React from "react"

import * as style from "./Body.module.scss"

const Body = ({ children }) => (
  <div id="body" className={style.body}>
    {children}
  </div>
)

export default Body
